<template>
  <div class="home">
    <div class="container-fluid px-0 px-md-4 px-lg-5">
      <GenericBanner id="IntroBanner" class="py-5" image="/home-banner-image_1.jpg">
        <h1 class="mb-5">
          Exceptional Expertise<br class="d-none d-md-block" />
          in electrical, networking and<br class="d-none d-md-block" />
          related services
        </h1>

        <router-link class="btn btn-light btn-lg rounded-0 text-uppercase px-4 px-lg-5" :to="{ hash: '#Contact' }">Contact Us</router-link>
      </GenericBanner>
    </div>

    <div id="About" class="py-5 mx-2 mx-md-4 mx-lg-5">
      <div class="container-fluid px-0 px-md-4 px-lg-5">
        <div class="row mb-4 mb-md-5 justify-content-lg--between align-item-center pb-2">
          <div class="col-lg-6 col-xl-4 order-lg-2 mx-lg-auto">
            <div id="aboutCarousel" class="carousel carousel-dark slide" >
              <div class="carousel-inner">
                <!-- TODO: once content determined, set a height on .carousel-item based on the height of the slide with the longest content -->
                <!-- TODO: check and alter heights on different screen sizes if necessary -->
                <div class=" my-0 my-md-5 carousel-item" v-for="(about, index) in AboutCopy" :key="'about-slide-' + index" :class="{'active': index == 0}">
                  <div class="col-12 d-flex justify-content-center">
                    <div class="col-10 col-xl-12">
                      <h2 class="mb-4">
                        {{ about.title }}
                      </h2>
                      <div v-html="about.copy" class="my-4 my-md-5"></div>
                      <router-link v-if="about.button.link.hash" class="btn btn-dark btn-lg rounded-0 text-uppercase px-4 px-lg-5"
                        :to="about.button.link.hash">
                        {{ about.button.text }}
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <button class="carousel-control-prev" type="button" data-bs-target="#aboutCarousel" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#aboutCarousel" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div class="col-lg-6 my-4 my-lg-0 d-flex align-items-center">
            <img class="img-fluid" src="@/assets/about-us-image_1.jpg" alt="" />
          </div>
        </div>
        <h2 class="text-center mb-4 mb-md-5">
          Why Choose Us
        </h2>
        <div class="row mb-4 justify-content-between">
          <div class="col-sm-6 col-md-3 col-xl-2 my-3 my-md-5 text-center" v-for="(aboutkey, index) in AboutContent" :key="'about-copy-' + index">
            <img class="img-fluid" :src="require('@/assets/' + aboutkey.image.replace(/^\//g, ''))" :alt="aboutkey.alt" />
            <h3 class="h5 text-primary mt-3">{{ aboutkey.title }}</h3>
            <div v-html="aboutkey.copy"></div>
          </div>
        </div>
      </div>
    </div>

    <div id="Services" class="bg-muted">
      <div class="py-5 mx-2 mx-md-4 mx-lg-5">
        <div class="container-fluid px-0 px-md-4 px-lg-5 my-4 my-md-5">
          <h2 class="text-center mb-4 mb-md-5">
            Our Services Include
          </h2>
          <div class="row g-xl-5 justify-content-center">
            <div class="col-11 col-sm-8 col-md-6 col-lg-4 my-4" v-for="(service, index) in ServicesContent" :key="'services-' + index">
              <div class="service-block d-flex flex-column" :style="`background-image:url(${require('@/assets/' + service.image.replace(/^\//g, ''))})`">
                <div class="text-center service-heading px-2 py-4 d-flex justify-content-center align-items-center">
                  <h3 class="h4 text-white mb-0">{{ service.title }}</h3>
                </div>
                <div class="text-center service-copy bg-white px-2 py-4 d-flex justify-content-center align-items-center">
                  <div v-html="service.copy"></div>
                </div>
              </div>
            </div>
            <div class="col-12 text-center">
              <router-link class="btn btn-dark btn-lg rounded-0 text-uppercase px-4 px-lg-5" :to="{ hash: '#Contact' }">Contact Us</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="Testimonials" class="py-5 mx-2 mx-md-4 mx-lg-5">
      <div class="container-fluid px-0 px-md-4 px-lg-5 my-4 my-md-5">
        <h2 class="text-center mb-4 mb-md-5">
          Our Happy Customers
        </h2>
        <div class="col-12 d-flex flex-wrap justify-content-center">
          <div class="col-md-12 col-xl-8 text-center my-4 mx-auto">
            <div id="testimonialsCarousel" class="carousel carousel-dark slide" >
              <div class="carousel-inner d-flex align-items-center">
                <!-- TODO: once content determined, set a height on .carousel-item based on the height of the slide with the longest content -->
                <!-- TODO: check and alter heights on different screen sizes if necessary -->
                <div class="carousel-item" v-for="(testimonial, index) in TestimonialContent" :key="'testimonial-' + index" :class="{'active': index == 0}">
                  <div class="col-12 d-flex justify-content-center">
                    <div class="col-10 col-xl-12">
                      <div>"{{ testimonial.quote }}"</div>
                      <p>{{ testimonial.person }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <button class="carousel-control-prev" type="button" data-bs-target="#testimonialsCarousel" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#testimonialsCarousel" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div class="row w-100 my-4 d-flex flex-wrap align-items-center justify-content-center">
            <div class="col-12 col-sm-3 text-center my-4 my-sm-2" v-for="(testimonial, index) in TestimonialLogos" :key="'testimonial-logo-' + index">
              <img class="img-fluid" :src="require('@/assets/' + testimonial.image.replace(/^\//g, ''))" :alt="testimonial.alt" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useHead } from "@unhead/vue";
  import GenericBanner from "@/components/banners/GenericBanner.vue";

  useHead({
    title: "",
    // meta: [
    //   { name: "description", content: "" },
    //   { name: "keywords", content: "", key: "keywords-tag" },
    //   { name: "robots", content: "", key: "robots-tag" }
    // ],
  })

  const AboutCopy = [
    // TODO: once content determined, set a height on .carousel-item based on the height of the slide with the longest content
    // TODO: check and alter heights on different screen sizes if necessary
    {
      title: "Professional. Committed. Hard working.",
      image: "",
      copy: `
        <p>We are a passionate team with a lot of experience in electrical and networking installation. </p>
        <p>Including electrical wiring and installations, Networking and Wi-Fi set ups, call and contact  centre set up, CCTV and IP Camera work. We also have experience in Home automation and smart device setup.</p>
        <p>We have also done many large scale inverter, battery and solar related installations in both residential and commercial settings.</p>
      `,
      button: {
        text: "Our Services",
        link: { hash: '#Services' },
      }
    },
    {
      title: "Tried and trusted!",
      image: "",
      copy: `
        <p>We've been in business for nearly 20 years and our reputation speaks for itself.</p>
        <p>Our clients are mostly based in KwaZulu Natal but we do jobs all around South Africa.</p>
      `,
      button: {
        text: "Our Testimonials",
        link: { hash: '#Testimonials' },
      }
    }
  ]

  const AboutContent = [
    {
      title: "Competitive Rates",
      image: "about-icon_1.png",
      alt: "Competitive Rates",
      copy: ``
    },
    {
      title: "20 Years of Expertise",
      image: "about-icon_2.png",
      alt: "20 Years of Expertise",
      copy: ``
    },
    {
      title: "Exceptional Service",
      image: "about-icon_3.png",
      alt: "Exceptional Service",
      copy: ``
    }
  ]

  const ServicesContent = [
    {
      title: "Electrical and related",
      image: "service-image_1.jpg",
      alt: "",
      copy: `From lighting to compliance and maintenance. We do everything electrical.`
    },
    {
      title: "Networking and CCTV",
      image: "service-image_2.jpg",
      alt: "",
      copy: `We set up networking equipment, including cabling, switching, routing and wi-fi. We also set up IP Cams and CCTV.`
    },
    {
      title: "Home Automation / Smart Devices.",
      image: "service-image_3.jpg",
      alt: "",
      copy: `We have experience in working with the Sonoff range of home automation and smart devices.`
    }
  ]

  const TestimonialContent = [
    {
      quote: `I've worked with Sabelo for more than 10 years, both in my home and business and he has only ever exceeded my expectations. He's reasonably priced, honest and hard working.`,
      person: "Jared Krause: Managing Director, Nologo Studios"
    },
    {
      quote: `I used Sabelo to install some home automation devices, he was excellent and very knowledgable and guided me every step of the way.`,
      person: "Matt Schnell"
    },
    {
      quote: `Sabelo is just amazing. I will continue to use him and recommend him.`,
      person: "Anonymous."
    }
  ]

  const TestimonialLogos = [
    {
      alt: "Nologo Studios Logo",
      image: "nslogo.png"
    },
    {
      alt: "Africa PC Logo",
      image: "africapc_logo.png"
    },
    {
      alt: "Unipower Logo",
      image: "unipower_logo.png"
    }
  ] 
</script>

<style lang="scss" scoped>
  #IntroBanner {
    @include media-breakpoint-up(md) {
      min-height: 85vh;
    }
  }

  #aboutCarousel {
    .carousel-control-prev {
      left: -80px;
    }
    .carousel-control-next {
      right: -80px;
    }

    @include media-breakpoint-down(xl) {
      .carousel-control-prev {
        left: -25px;
      }
      .carousel-control-next {
        right: -25px;
      }
    }

    @include media-breakpoint-down(sm) {
      .carousel-control-prev {
        left: -15px;
      }
      .carousel-control-next {
        right: -15px;
      }
    }
  }

  #testimonialsCarousel {
    .carousel-inner {
      min-height: 150px;
    }

    .carousel-control-prev {
      left: -120px;
    }
    .carousel-control-next {
      right: -120px;
    }

    @include media-breakpoint-down(xl) {
      .carousel-control-prev {
        left: -25px;
      }
      .carousel-control-next {
        right: -25px;
      }
    }

    @include media-breakpoint-down(sm) {
      .carousel-control-prev {
        left: -15px;
      }
      .carousel-control-next {
        right: -15px;
      }
    }
  }

  .service-block {
    aspect-ratio: 1/1;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;

    .service-heading {
      height: 100%;
      max-height: 50%;
      transition: max-height 200ms ease-out;
      transition-delay: 100ms;
    }

    .service-copy {
      height: 50%;
      font-size: 16px;
      transition: opacity 100ms ease-out;
      line-height: 1.3;
    }

    @include media-breakpoint-down(sm) {
      aspect-ratio: unset;
      
      .service-heading {
        max-height: 30%;
      }

      .service-copy {
        height: 70%;
      }
    }

    @include media-breakpoint-up(lg) {
      .service-heading {
        max-height: 100%;
      }
      .service-copy {
        opacity: 0;
        position: absolute;
        bottom: 0;
      }

      &:hover {
        .service-heading {
          max-height: 30%;
          transition: max-height 100ms ease-in;
          transition-delay: 0;
        }
        .service-copy {
          height: 70%;
          opacity: 1;
          transition: opacity 200ms ease-in;
          transition-delay: 100ms;
        }
      }
    }

    @include media-breakpoint-up(xl) {
      &:hover {
        .service-heading {
          max-height: 50%;
        }
        .service-copy {
          height: 50%;
        }
      }
    }

    @include media-breakpoint-up(xxl) {
      .service-copy {
        font-size: 17px;
      }
    }
  }
</style>